import { render } from "./Search.component.vue?vue&type=template&id=ee4cf0ac"
import script from "./Search.component.vue?vue&type=script&lang=js"
export * from "./Search.component.vue?vue&type=script&lang=js"

import "./Search.component.vue?vue&type=style&index=0&id=ee4cf0ac&lang=css"

import exportComponent from "/home/debian/oni-ui/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__